const {Component} = require("react");
const PropTypes = require("prop-types");
const nevermore = require("nevermorejs");
const {classList} = require("helpers/html");
const shortid = require("shortid");
const assign = require("object-assign");
const {queryObject, cloneObject, pluckKeysExcept} = require("helpers/object");
const Plugins = require("nevermorejs/plugins");
const Screen = require("services/screen");

// Default language
const defaultLanguage = {
	previousMonth: "",
	nextMonth: "",
	allWeeks: "Alle uger",
	month: (dateMoment) => dateMoment.format("MMMM YYYY"),
	setWeek: (dateMoment) => `Uge ${dateMoment.isoWeek()}`,
	day: (dateMoment) => dateMoment.format("dddd"),
	isoWeek: (dateMoment) => `Uge ${dateMoment.isoWeek()}`,
	date: (dateMoment) => dateMoment.format("DD MMMM"),
	hour: (dateMoment) => dateMoment.format("HH:mm"),
	repeater: (dateMoment) => `Gentages hver ${dateMoment.format("ddd")}`,
	dayDate: (dateMoment) => dateMoment.format("ddd. DD MMM")
};

class Nevermore extends Component {

	static get propTypes() {
		return {
			value: PropTypes.array,
			defaultValue: PropTypes.array,
			plugins: PropTypes.array,
			handleChange: PropTypes.func,
			handleAdd: PropTypes.func,
			handleRemove: PropTypes.func,
			handleItemChange: PropTypes.func,
			addMiddleware: PropTypes.func,
			removeMiddleware: PropTypes.func,
			changeMiddleware: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			plugins: []
		};
	}

	constructor(props) {
		super(props);
		this.state = {
			value: props.value || props.defaultValue || []
		};
	}

	get language() {
		let lang = defaultLanguage;

		if (Screen.desktop()) return lang;

		lang.day = (dateMoment) => dateMoment.format("ddd");
		lang.date = (dateMoment) => dateMoment.format("DD MMM");

		return lang;

	}

	get defaultPlugins() {
		if (Screen.desktop()) return Plugins.defaultPlugins;

		let plugins = [];
		let mobile = [
			'MonthControl',
			'WeekControl',
			'BoundaryDetection',
			'TimeSnap',
			'DurationLimit',
			'DragCreate',
		];

		mobile.forEach(key => {
			let plugin = queryObject(Plugins, key);
			if (plugin) {
				plugins.push(plugin);
			}
		});

		return plugins;
	}

	get options() {
		return pluckKeysExcept(this.props, Object.keys(this.constructor.propTypes));
	}

	handleChange = () => {
		if (typeof this.props.handleChange === "function") {
			this.props.handleChange(this.state.value);
		}
	};

	handleAdd = (item, data) => {
		if (typeof this.props.handleAdd === "function") {
			this.props.handleAdd(item, data);
		}
	};

	handleRemove = (item, data) => {
		if (typeof this.props.handleRemove === "function") {
			this.props.handleRemove(item, data);
		}
	};

	handleItemChange = (item, data) => {
		if (typeof this.props.handleItemChange === "function") {
			this.props.handleItemChange(item, data);
		}
	};

	get value() {
		return this.state.value;
	}

	replaceValue(newValue) {
		this.setState({value: newValue}, () => {
			this.instance.replaceItems(newValue);
		});
	}

	componentDidMount() {
		const instance = this.instance = nevermore(this.element, assign(this.options, {
			language: this.language,
			plugins: [].concat(this.defaultPlugins, this.props.plugins),
			items: this.state.value
		}));

		// bind events
		instance.on("add", item => {
			// Generate temporary id
			item.data.id = shortid.generate();

			const itemData = assign({}, item.data, {
				from: item.from.format("YYYY-MM-DD HH:mm:ss"),
				to: item.to.format("YYYY-MM-DD HH:mm:ss"),
				repeater: cloneObject(item.repeater),
			});

			// Push a copy to the state
			this.setState(state => {
				state.value.push(itemData);
				return state;

			}, () => {
				this.handleAdd(item, itemData);
				this.handleChange();
			});
		});

		instance.on("remove", item => {
			const index = this.state.value.findIndex(itemData => itemData.id === item.data.id);
			const itemData = index > -1 ? this.state.value[index] : null;

			if (itemData) {
				this.setState(state => {
					state.value.splice(index, 1);
					return state;
				}, () => {
					this.handleRemove(item, itemData);
					this.handleChange();
				});
			}
		});

		instance.on("change", item => {
			const index = this.state.value.findIndex(itemData => itemData.id === item.data.id);
			let itemData = index > -1 ? this.state.value[index] : null;

			if (itemData) {
				this.setState(state => {
					itemData = assign(itemData, item.data, {
						from: item.from.format("YYYY-MM-DD HH:mm:ss"),
						to: item.to.format("YYYY-MM-DD HH:mm:ss"),
						repeater: cloneObject(item.repeater)

					});

					state.value[index] = itemData;
					return state;
				}, () => {
					this.handleItemChange(item, itemData);
					this.handleChange();
				});
			}
		});

		// Add middleware
		instance.onItemAdd.eager(payload => {
			if (typeof this.props.addMiddleware === "function") {
				const result = this.props.addMiddleware(payload);

				if (result != undefined) {
					return result;
				}
			}

			return payload;
		});

		// Remove middleware
		instance.onItemRemove.eager(payload => {
			if (typeof this.props.removeMiddleware === "function") {
				const result = this.props.removeMiddleware(payload);

				if (result != undefined) {
					return result;
				}
			}

			return payload;
		});

		// Change middleware
		instance.onItemChange.eager(payload => {
			if (typeof this.props.changeMiddleware === "function") {
				const result = this.props.changeMiddleware(payload);

				if (result != undefined) {
					return result;
				}
			}

			return payload;
		});
	}

	render() {
		return (
			<div className={this.props.className} ref={el => this.element = el}></div>
		);
	}

}

module.exports = Nevermore;



// WEBPACK FOOTER //
// ./resources/js/components/backend/calendar/Nevermore.js